import React from 'react'
import classNames from 'classnames'

export default function Title({
    children,
    component,
    color,
    large,
    huge,
    dashboard,
    center,
    bold,
    light,
    className = ""
}) {

    const Component = component || "div"

    let classes = typeof className === "string" ? className.split(" ").reduce((acc, item) => {
        acc[item] = true
        return acc
    }, {}) : className;

    const Classes = classNames({
        "block leading-tight": true,
        "text-lg md:text-xl": !large && !huge && !dashboard,
        "font-medium": !bold && !light && !dashboard,
        "text-xl md:text-2xl": large,
        "text-xl md:text-huge": huge,
        "text-3xl md:text-dashboard": dashboard,
        "font-bold": bold,
        "font-regular": light,
        "text-center": center,
        [`text-${color}`]: color,
        ...classes
    })

    return (
        <Component className={Classes}>{children}</Component>
    )
}
